/**
 * File booking.js
 *
 * To manage the Booking module
 *
 * Learn more: https://saint-augustin.ch
 */

import BookingDataProvider from '../context/BookingDataProvider'
import SelectionSummary from './SelectionSummary';
import CalendarsDisplay from "./CalendarsDisplay";
import ChoicesForm from './ChoicesForm'
import BookingForm from './BookingForm'

import '../styles/BookingApp.css'

const BookingApp = () => {
    return (
        <BookingDataProvider>
            <div className="wp-block-columns">
                <div className="wp-block-column">
                    <div className="wp-block-group__inner-container">
                        <h1>1. Vérifier la disponibilité</h1>
                        <CalendarsDisplay />
                    </div>
                </div>
                <div className="wp-block-column">
                    <div className="wp-block-group__inner-container">
                        <h1>2. Sélectionner salle et équipement désirés</h1>
                        <ChoicesForm />
                    </div>
                </div>
            </div>
            <h1>3. Envoyer la réservation</h1>
            <div className="wp-block-columns">
                <div className="wp-block-column">
                    <div className="wp-block-group__inner-container">
                        <SelectionSummary />
                    </div>
                </div>
                <div className="wp-block-column">
                    <div className="wp-block-group__inner-container">
                        <BookingForm />
                    </div>
                </div>
            </div>
        </BookingDataProvider>
    )
}

export default BookingApp;
